export default function InstallationsService(
  $http,
  appSettings,
  InstallationsMockService,
  activationsRepo
) {
  'ngInject';
  const base = `${appSettings.IcebergApiInstallationsEndpoint}/installations`;

  if (appSettings.FixturesModeEnabled) {
    return InstallationsMockService;
  }

  // GET paged installations
  this.getInstallations = function (
    limit,
    sort,
    since,
    deviceSerialNumber,
    installationId
  ) {
    let endpoint = `${base}`;
    let queryString = new Array();

    if (limit) queryString.push('limit=' + limit);
    if (sort) queryString.push('sort=' + sort);
    if (since) queryString.push('since=' + since);
    if (deviceSerialNumber)
      queryString.push('device.serialnumber=' + deviceSerialNumber);
    if (installationId) queryString.push('ids=' + installationId);

    if (queryString.length > 0) endpoint += `?${queryString.join('&')}`;

    return $http.get(endpoint);
  };

  this.getInstallationById = function (id) {
    const endpoint = `${base}/${id}`;
    return $http.get(endpoint);
  };

  this.createInstallation = function (newInstallation, sgResource) {
    const endpoint = `${base}`;

    if (sgResource) {
      return $http({
        method: 'POST',
        url: endpoint,
        headers: {
          'X-Init-Security-Group': sgResource
        },
        data: JSON.stringify(newInstallation)
      });
    } else {
      return $http.post(endpoint, newInstallation);
    }
  };

  this.deleteInstallation = function (installationId) {
    const endpoint = `${base}/${installationId}`;
    return $http.delete(endpoint);
  };
  this.getInstallationByequipID = function (equipId) {
    const endpoint = `${base}?equipment.id=${equipId}`;
    return $http.get(endpoint);
  };

  this.syncRunHours = function (installationId, runHours) {
    var syncRequest = this.createSyncRequest(installationId, runHours);
    return activationsRepo.syncRunHours(syncRequest).then(function (response) {
      return {
        value: parseFloat(response.data[0].value)
      };
    });
  };

  this.createSyncRequest = function (installationId, runHours) {
    var req = {
      method: 'POST',
      url: `${
				appSettings.InReachApiInstallationsEndpoint
			}/${installationId}/runhours`,
      data: JSON.stringify({
        value: runHours
      })
    };
    return req;
  };
}